import React from 'react';
import { Checkbox as CheckboxBase } from '@gravity-ui/uikit';
import { block } from '../../../utils';
import './Checkbox.css';
const b = block('checkbox');
export const Checkbox = ({ name, input, spec, inputProps }) => {
    const { value, onBlur, onChange, onFocus } = input;
    const handleChange = React.useCallback((e) => onChange(e.target.checked), [onChange]);
    return (React.createElement("div", { className: b() },
        React.createElement(CheckboxBase, Object.assign({}, inputProps, { checked: value, onChange: handleChange, onBlur: onBlur, onFocus: onFocus, disabled: spec.viewSpec.disabled, qa: name }))));
};
